import axios from "axios"
import store from '@/store'

const http = axios.create({ baseURL: process.env.VUE_APP_ROOT_API })

const guests = [
    '/autenticacao/login',
    '/autenticacao/recuperar-senha',
]

http.interceptors.request.use(request => {
    const cliente = store.state.cliente || {}
    const token = store.state.token || null
    
    if (token && guests.indexOf(request.url) === -1) {
        request.headers['Authorization'] = `Bearer ${token}`
    } else {
        request.headers['cliente'] = cliente.link
    }

    return request
}, error => Promise.reject(error))

http.interceptors.response.use(response => {
    return response
}, error => Promise.reject(error))

export default http